import { IProfileForm } from "../model/newProfileModel"
import { apiCallNoResponse } from "./sharedAsync";

export const apiSubmitNewProfile = async (payload: IProfileForm, rejectWithValue: (value: string)=>void): Promise<void> => {
    return apiCallNoResponse<IProfileForm>("", "/application/submit", "POST", rejectWithValue, "Failed to submit profile form.", payload);
}